import { css } from 'linaria';
import { breakpointLargeHandset } from '@pocket/web-ui';
import ReactMarkdown from 'react-markdown';
const Headline = "hmjyd8t";
const Description = "d149txkx";
/**
 * Pulls the headline from the ‘Title’ field in the admin editor tool,
 * and the description uses the content from the “Excerpt” field in the admin tool.
 *
 * Editors look at the syndicated stories so they adjust headlines and dek in the
 * admin tool if it is too long or more than than 3 lines
 */

export function ParsedHeadline({
  title,
  description,
  useMarkdown
}) {
  return <>
      <h1 className={Headline} data-cy="parsed-headline">{title}</h1>
      <h2 className={Description}>
        {useMarkdown ? <ReactMarkdown skipHtml={true} unwrapDisallowed={true} allowedElements={['strong', 'em']}>
            {description}
          </ReactMarkdown> : <p>{description}</p>}
      </h2>
    </>;
}

require("./parsed-headline.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./parsed-headline.js");